// LIST
export const FETCH_STEPS = "app/STEP/FETCH_STEPS";
export const FETCH_STEPS_SUCCESS = "app/STEP/FETCH_STEPS_SUCCESS";
export const FETCH_STEPS_FAILURE = "app/STEP/FETCH_STEPS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/STEP/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/STEP/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/STEP/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_STEP = "app/STEP/ADD_STEP";
export const ADD_STEP_SUCCESS = "app/STEP/ADD_STEP_SUCCESS";
export const ADD_STEP_FAILURE = "app/STEP/ADD_STEP_FAILURE";

// EDIT
export const EDIT_STEP = "app/STEP/EDIT_STEP";
export const EDIT_STEP_SUCCESS = "app/STEP/EDIT_STEP_SUCCESS";
export const EDIT_STEP_FAILURE = "app/STEP/EDIT_STEP_FAILURE";

// DELETE
export const DELETE_STEP = "app/STEP/DELETE_STEP";
export const DELETE_STEP_SUCCESS = "app/STEP/DELETE_STEP_SUCCESS";
export const DELETE_STEP_FAILURE = "app/STEP/DELETE_STEP_FAILURE";

export const TOGGLE_STEP_ADD_MODAL = "app/STEP/TOGGLE_STEP_ADD_MODAL";

export const UPDATE_STEP_ORDER = "app/STEP/UPDATE_STEP_ORDER";
export const UPDATE_STEP_ORDER_SUCCESS = "app/STEP/UPDATE_STEP_ORDER_SUCCESS";
export const UPDATE_STEP_ORDER_FAILURE = "app/STEP/UPDATE_STEP_ORDER_FAILURE";

export const VALIDATE_DELETE = "app/STEP/VALIDATE_DELETE";
export const VALIDATE_DELETE_SUCCESS = "app/STEP/VALIDATE_DELETE_SUCCESS";
export const VALIDATE_DELETE_FAILURE = "app/STEP/VALIDATE_DELETE_FAILURE";

export const TOGGLE_STEP_DELETE_MODAL = "app/STEP/TOGGLE_STEP_DELETE_MODAL";
